(()=>{
  const init=root=>{
    if(root.dataset.ready)return;
    root.dataset.ready='true';
    const $=s=>root.querySelector(s),$$=s=>[...root.querySelectorAll(s)];
    const product=JSON.parse($('[data-product-data]').textContent),s=product.strings;
    const form=$('.l7p-form'),quantity=form.elements.quantity;
    const base=root.dataset.root||'/';
    const money=n=>new Intl.NumberFormat(root.dataset.locale||'en-US',{style:'currency',currency:root.dataset.currency||'USD'}).format(n/100);
    const sellable=v=>!!v&&(v.qty>0||(v.available&&(v.tracked===false||v.policy==='continue')));
    let selected=product.variants.find(v=>v.id===product.selectedId),photos=[],busy=false,cartBusy=false;
    const api=async(path,data)=>{
      const response=await fetch(base+path,{credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},...(data?{method:'POST',body:JSON.stringify(data)}:{})});
      const result=await response.json();
      if(!response.ok)throw Error(result.description||result.message||s.error);
      return result;
    };
    function photo(index){
      const p=photos[index];if(!p)return;
      const main=$('.l7p-main-image');
      if(main){main.removeAttribute('srcset');main.removeAttribute('sizes');main.src=p.url;main.alt=p.alt;}
      $('[data-lightbox] img').src=p.url;
      $('[data-lightbox] img').alt=p.alt;
      $('[data-photo-note]').textContent=p.alt.split(' — ')[0];
      $$('[data-photo]').forEach(b=>b.setAttribute('aria-pressed',String(Number(b.dataset.photo)===index)));
    }
    function gallery(){
      const colorIndex=product.optionNames.findIndex(n=>/^colou?r$/i.test(n));
      const color=String(selected?.options[colorIndex]||'').trim().toLowerCase();
      const matches=color?product.photos.filter(p=>p.alt.split('|')[0].trim().toLowerCase()===color):[];
      if(matches.length){
        photos=matches.slice().sort((a,b)=>Number(/\|\s*back\b/i.test(b.alt))-Number(/\|\s*back\b/i.test(a.alt)));
        photos.push(...product.photos.filter(p=>/^size guide\s*\|/i.test(p.alt)));
      }else{
        photos=product.photos.slice();
        const index=photos.findIndex(p=>p.id===selected?.imageId);
        if(index>0)photos.unshift(...photos.splice(index,1));
      }
      const thumbs=$('[data-thumbnails]');thumbs.replaceChildren();
      photos.forEach((p,index)=>{
        const b=document.createElement('button');b.type='button';b.dataset.photo=index;b.setAttribute('aria-label',p.alt);b.setAttribute('aria-pressed',String(index===0));
        const img=document.createElement('img');img.src=p.thumb;img.alt='';img.width=80;img.height=80;img.loading='lazy';b.append(img);thumbs.append(b);
      });
      photo(0);
    }
    function update(){
      const available=sellable(selected);
      const count=Math.max(1,Math.min(Number(quantity.max)||999,Math.floor(Number(quantity.value)||1)));
      quantity.value=count;
      $('[data-variant-id]').value=selected?.id||'';
      $('[data-price]').textContent=money(selected?.price??product.variants[0].price);
      const compare=$('[data-compare]');compare.hidden=!(selected?.compare>selected?.price);compare.textContent=selected?.compare?money(selected.compare):'';
      $('[data-total]').textContent=money((selected?.price||0)*count);
      $('[data-add]').disabled=!available||busy;
      $('[data-add]').textContent=busy?s.adding:!selected?s.unavailable:available?s.add+' +':s.sold;
      $('[data-stock]').textContent=available?s.inStock:selected?s.sold:s.unavailable;
      $('[data-stock]').classList.toggle('is-unavailable',!available);
      if(selected){const u=new URL(location.href);u.searchParams.set('variant',String(selected.id));history.replaceState({},'',u);}
    }
    function choose(){
      const values=$$('[data-option-index]').map(group=>group.querySelector('input:checked')?.value);
      selected=product.variants.find(v=>v.options.every((value,i)=>value===values[i]));
      $$('[data-option-index]').forEach(group=>{
        const index=Number(group.dataset.optionIndex);group.querySelector('[data-option-value]').textContent=values[index]||'';
        group.querySelectorAll('input').forEach(input=>{
          const possible=product.variants.some(v=>v.options[index]===input.value&&v.options.every((value,i)=>i===index||value===values[i])&&sellable(v));
          input.parentElement.classList.toggle('l7p-unavailable',!possible);
        });
      });
      $('[data-status]').textContent='';update();gallery();
    }
    function show(dialog){if(!dialog.open)dialog.showModal();}
    function close(dialog){dialog.close();}
    async function cart(){
      const data=await api('cart.js');
      $('[data-bag-count]').textContent=data.item_count;
      $('[data-cart-items]').textContent='('+data.item_count+')';
      $('[data-cart-subtotal]').textContent=money(data.total_price);
      const container=$('[data-cart-lines]');container.replaceChildren();
      if(!data.item_count){const p=document.createElement('p');p.textContent=s.empty;container.append(p);}
      data.items.forEach(item=>{
        const line=document.createElement('article');line.className='l7p-cart-line';
        const img=document.createElement('img');img.src=item.image||'';img.alt=item.product_title;img.width=90;img.height=100;line.append(img);
        const info=document.createElement('div');const title=document.createElement('a');title.href=item.url;title.textContent=item.product_title;info.append(title);
        const variant=document.createElement('p');variant.textContent=item.variant_title==='Default Title'?'':item.variant_title||'';info.append(variant);
        const price=document.createElement('strong');price.textContent=money(item.final_line_price);info.append(price);
        const row=document.createElement('div');row.className='l7p-cart-actions';
        const input=document.createElement('input');input.type='number';input.min='0';input.max='999';input.value=item.quantity;input.setAttribute('aria-label',s.quantity+' — '+item.product_title);input.dataset.cartKey=item.key;row.append(input);
        const remove=document.createElement('button');remove.type='button';remove.textContent=s.remove;remove.dataset.removeKey=item.key;row.append(remove);info.append(row);line.append(info);container.append(line);
      });
      $('[data-checkout]').hidden=!data.item_count;
    }
    async function openCart(){try{await cart();show($('[data-cart-dialog]'));}catch(error){$('[data-status]').textContent=error.message;}}
    form.addEventListener('submit',async event=>{
      event.preventDefault();if(!sellable(selected)||busy)return;
      busy=true;update();$('[data-status]').textContent='';
      try{await api('cart/add.js',{items:[{id:selected.id,quantity:Number(quantity.value)}]});$('[data-status]').textContent=s.added;await openCart();}
      catch(error){$('[data-status]').textContent=error.message;}
      finally{busy=false;update();}
    });
    root.addEventListener('click',async event=>{
      const thumb=event.target.closest('[data-photo]');if(thumb){photo(Number(thumb.dataset.photo));return;}
      const step=event.target.closest('[data-qty-step]');if(step){quantity.value=Math.max(1,Number(quantity.value||1)+Number(step.dataset.qtyStep));update();return;}
      if(event.target.closest('[data-zoom-open]'))show($('[data-lightbox]'));
      if(event.target.closest('[data-zoom-close]'))close($('[data-lightbox]'));
      if(event.target.closest('[data-bag-open]')){event.preventDefault();openCart();}
      if(event.target.closest('[data-cart-close]'))close($('[data-cart-dialog]'));
      const remove=event.target.closest('[data-remove-key]');
      if(remove&&!cartBusy){cartBusy=true;remove.disabled=true;try{await api('cart/change.js',{id:remove.dataset.removeKey,quantity:0});await cart();}catch(error){$('[data-status]').textContent=error.message;}finally{cartBusy=false;}}
    });
    root.addEventListener('change',async event=>{
      if(event.target.matches('.l7p-options input'))choose();
      if(event.target===quantity)update();
      if(event.target.matches('[data-cart-key]')&&!cartBusy){cartBusy=true;try{await api('cart/change.js',{id:event.target.dataset.cartKey,quantity:Math.max(0,Math.floor(Number(event.target.value)||0))});await cart();}catch(error){$('[data-status]').textContent=error.message;}finally{cartBusy=false;}}
    });
    $$('dialog').forEach(dialog=>dialog.addEventListener('click',event=>{if(event.target!==dialog)return;const rect=dialog.getBoundingClientRect();if(event.clientX<rect.left||event.clientX>rect.right||event.clientY<rect.top||event.clientY>rect.bottom)close(dialog);}));
    if(product.optionNames.length&&$$('[data-option-index]').length)choose();else{update();gallery();}
  };
  document.querySelectorAll('.l7-product').forEach(init);
  document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('.l7-product').forEach(init));
})();
